import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLocalEntity = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "0.875em",
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M3.33333 4.99998H16.6667V13.3333H3.33333V4.99998ZM16.6667 15C17.1087 15 17.5326 14.8244 17.8452 14.5118C18.1577 14.1993 18.3333 13.7753 18.3333 13.3333V4.99998C18.3333 4.07498 17.5833 3.33331 16.6667 3.33331H3.33333C2.40833 3.33331 1.66667 4.07498 1.66667 4.99998V13.3333C1.66667 13.7753 1.84226 14.1993 2.15482 14.5118C2.46738 14.8244 2.89131 15 3.33333 15H0V16.6666H20V15H16.6667Z",
		fill: "currentColor"
	})
});
export default SvgLocalEntity;
